import denominationComponent from './denomination.component';
import DenominationCreate from './create'
import DenominationEdit from './edit'
import DenominationAll from './all'

let denominationModule = angular.module('denomination', [
  DenominationCreate,
  DenominationEdit,
  DenominationAll
  ])

  .component('denomination', denominationComponent)

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $stateProvider
      .state('denomination.edit', {
        url: '/edit/:id',
        component: 'denominationedit',
        data: {
          requireACL: 'tnt_control_denomination.edit'
        }
      })

      .state('denomination.create', {
        url: '/create',
        component: 'denominationcreate',
        data: {
          requireACL: 'tnt_control_denomination.create'
        }
      })

      .state('denomination.all', {
        url: '/all/:page',
        component: 'denominationall',
        data: {
          requireACL: 'tnt_control_denomination.view'
        }        
      });
    $urlRouterProvider.when('/denomination', '/denomination/all/1');
  })

  .name;

export default denominationModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/denomination/index.js